module.exports = __webpack_public_path__ + "img/business-solutions-secondary-hero-mobile.ff861962.webp";